export default {
    inviteUsers: '/community/inviteusers/',
    managePermissions: '/community/managepermissions/',
    editCommunityDetails: '/community/editdetails/',
    manageUsers: '/community/manageusers/',
    approveUsers: '/community/requests/',
    premium: '/community/premium/',
    addTopic: '/create/question/ask/',
    addAssignment: '/create/assignment/',
    home: '/home',
    communityHome: '/community/home/',
    communityAbout: '/community/about/',
    communityAssignments: '/community/home/assignments/',
    templates: '/community/templates',
    communityTypes: '/community/types',
    publicCommunity: '/create/community/public',
    privateCommunity: '/create/community/private',
    previewTemplate: '/community/template/preview',
    myProfile: '/myprofile',
    termsConditions: '/termsandconditions',
    privacyPolicy: '/privacypolicy',
    communities: '/communities',
    notifications: '/notifications',
    feedbackform: '/feedbackform',
    queDetails: '/topic/',
    assignmentDetails: '/community/home/assignment/',
    pollDetails: '/poll/',
    myThreads: '/mythreads',
    topCommunities: '/topcommunities',
    aboutUs: '/about',
    communityGuidelines: '/community/guidelines',
}